export const HealthInfo = [
    { label: "No Health Problem", value: "No Health Problem" },
    { label: "Diabetes", value: "Diabetes" },
    { label: "Low BP", value: "Low BP" },
    { label: "Hight BP", value: "Hight BP" },
    { label: "Heart Aliments", value: "Heart Aliments" },
    { label: "HIV positive", value: "HIV positive" },
    { label: "Other", value: "Other" }
]
